import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground: ", ";\n\tbottom: -1px;\n\theight: 2px;\n\tleft: 0;\n\tposition: absolute;\n\ttransition: all ", " ease;\n\tz-index: 1;\n"]);

  _templateObject6 = function () {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\toutline: none;\n"]);

  _templateObject5 = function () {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tmin-height: ", ";\n"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tmin-height: ", ";\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\talign-items: center;\n\tappearance: none;\n\tbackground: transparent;\n\tborder: none;\n\tcolor: ", ";\n\tcursor: pointer;\n\tflex: 1;\n\tjustify-content: center;\n\tmin-height: ", ";\n\toutline: none;\n\tpadding: 4px;\n\ttransition: color ", " linear;\n\n\t&[aria-selected='true'] {\n\t\tcolor: ", ";\n\t}\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-bottom: 1px solid ", ";\n\tdisplay: flex;\n\toutline: none;\n\tposition: relative;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, styled, ui } from '@wp-g2/styles';
export var TabListView = styled.div(_templateObject(), ui.get('colorDivider'));
export var TabView = styled.button(_templateObject2(), ui.color.text, ui.get('controlHeightXLarge'), ui.get('transitionDuration'), ui.color.admin);
export var small = css(_templateObject3(), ui.get('controlHeightLarge'));
export var xSmall = css(_templateObject4(), ui.get('controlHeight'));
export var TabPanelView = styled.div(_templateObject5());
export var TabIndicatorView = styled.div(_templateObject6(), ui.color.admin, ui.get('transitionDuration'));